( function () {
    'use strict';
    espresso.ecom.productgrid = {};
    espresso.ecom.productgrid.init = function () {
        if ( jQuery( '.e-ecom-grid' ).length === 1 && jQuery( '.e-productdetails' ).length === 0 ) {
            espresso.ecom.productlist.sort.init();
            espresso.ecom.productlist.filter.init();
        }
    };
}() );
